export enum MemberType {
  A = 1,
  B = 2,
  C = 3
}